import { render, staticRenderFns } from "./PrestaList.vue?vue&type=template&id=2ebb37af"
import script from "./PrestaList.vue?vue&type=script&lang=js"
export * from "./PrestaList.vue?vue&type=script&lang=js"
import style0 from "./PrestaList.vue?vue&type=style&index=0&id=2ebb37af&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports